<template>
  <div id="section2">
    <div class="fondoWhite">
      <div class="wrapper">
        <b-container fluid>
          <b-container class="text-center">
            <br>
            <h2>{{ $t("p3s1Title") }}</h2>
            <br>
            <b-row>
              <b-col cols="12">
                <p class="text-left">
                  {{ $t("p3s2Texto1") }}
                </p>
                <br>
                <p class="text-left">
                  {{ $t("p3s2Texto2") }}
                </p>
              </b-col>
            </b-row>
            <br>
          </b-container>
        </b-container>
      </div>
    </div>
  </div>
</template>

<i18n>
{
  "en":{
    "p3s1Title": "We are waiting for you!",
    "p3s2Texto1": "AICAD Business School was born from the need that has existed among many students and professionals in search of expanding their horizons and experiences at a professional and academic level. Under this premise, we have been concerned with providing the best service and management, knowing how difficult it can be for university students to get tailored internships with favorable conditions for their professional growth. That is why we focus on having the best experience in internships, even abroad, so that you do not have to worry about its management, the credibility and trajectory of the company, paperwork or language barriers.",
    "p3s2Texto2": "We are an intermediary that facilitates contact with the company and provides you with all the help you need to manage your business practices. We function as a mediator selecting and publishing specific announcements for students and scholarship holders. We establish links between partner companies who are in search of young talent and students who seek to succeed  and who have chosen to learn,  take on new challenges, and benefit from the internship experience. We seek to turn your stay in the company into a unique experience that will boost your professional success."
  },
  "es":{
    "p3s1Title": "¡Estamos esperando por ti!",
    "p3s2Texto1": "AICAD Business School nace de la necesidad que ha existido entre muchos estudiantes y profesionales en búsqueda de ampliar sus horizontes y experiencias a nivel profesional y académico. Bajo esta premisa, en el ámbito de las prácticas profesionales en empresas, nos hemos preocupado por brindar el mejor servicio y gestión, conociendo lo difícil que puede llegar a ser para un estudiante universitario o becario el conseguir prácticas a su medida y en condiciones favorables para su crecimiento profesional. Es por ello que nos enfocamos en que puedas tener la mejor experiencia en prácticas, incluso en el extranjero, para que no tengas que preocuparte por la gestión de la misma, la credibilidad y trayectoria de la empresa, papeleo o por barreras idiomáticas.",
    "p3s2Texto2": "Somos un intermediario que te facilita el contacto con la empresa y te proporciona toda la ayuda que necesitas para gestionar tus prácticas en empresas. AICAD Business School funciona como un intermediario que selecciona y publica anuncios específicos para estudiantes y becario. Establecemos vínculos entre empresas y compañías de todas las áreas que están en la búsqueda de talento joven y estudiantes que buscan superarse y que decidan asumir los nuevos retos y aprendizajes que traen consigo la experiencia de prácticas en empresas. Buscamos convertir ese vínculo y tu estadía en la empresa en una vivencia única que te catapulte hacia el éxito profesional."
  }
}
</i18n>

<script>
export default {
    data() {
        return {
      
        }
    }
};
</script>
